import { ElementType, IElement } from "../IProcessData";
import { IMigrationParameters } from ".";
import { remoteCallParameterName, timeoutMinutesParameterName } from '../../components/CallActivity/CallActivityRemoteExecutionEditor';

export function migrate(migrateParameters: IMigrationParameters) {
    const element = migrateParameters.element;
    if (element &&
        element.type === ElementType.GlobalErrorHandler ||
        element.type === ElementType.CallActivity && 
        element.parameters[timeoutMinutesParameterName] === undefined &&
        element.parameters[remoteCallParameterName] != null && 
        element.parameters[remoteCallParameterName] == true) {
            const parameterCopy = Object.assign({}, element.parameters);
            parameterCopy[timeoutMinutesParameterName] = 180;
            const migratedElement = Object.assign({}, element, {parameters: parameterCopy});
            return migratedElement;
    }
    return element;
}
